import React from 'react';
import { Construction } from 'lucide-react';

const ZeriZhuanye = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction className="w-8 h-8 text-indigo-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">专业版择日</h1>
        <p className="text-gray-500 mb-6">
          该功能正在紧锣密鼓地开发中，将为您提供更深度的择日分析服务。敬请期待！
        </p>
        <div className="h-1 w-24 bg-indigo-100 rounded-full mx-auto">
          <div className="h-1 w-full bg-indigo-600 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default ZeriZhuanye;